import React from "react";
import { CssBaseline, Typography, Box } from "@mui/material"
import Map from "./Map";
import FacebookComponent from "../FooterIcons/FacebookComponent";
import InstagramComponent from "../FooterIcons/InstagramComponent";

function FooterPage () {
    return (
        <>
        <CssBaseline />
        <Map />
        <Box sx={{backgroundColor:'#424242' ,display:'flex', justifyContent:'center',  alignItems:'center', textAlign:'center' ,height:'50px'}}>
          <FacebookComponent />
          <InstagramComponent />
          <Typography sx={{color:'white', ml:'auto', mr:'4px'}}>
            Copyright ©2024 - Academia Billy Gym
          </Typography>
        </Box>
        </>
    );
};
export default FooterPage;